import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ConnectButton from '@/pages/_banner/ConnectButton';
import Wrapper from '@/pages/_banner/Wrapper';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '@/dialogs_new/DialogManager';
import useRouter from '@/hooks/useRouter';

DraftBanner.propTypes = {
  creator: PropTypes.shape({}),
  event: PropTypes.shape({
    id: PropTypes.number
  }).isRequired
};

export default function DraftBanner(props) {
  const { event, creator } = props;
  const { t } = useTranslation();

  const launch = useDialogLauncher();
  const { history } = useRouter();

  function onCancel() {
    launch(DialogManager.EventClose.Config(event.id));
  }

  return (
    <Wrapper
      color="gray"
      creator={creator}
      title={t('events.draft_banner.title')}
      subtitle={t('events.draft_banner.subtitle')}
    >
      <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
        <ConnectButton outline={true} onClick={onCancel}>
          {t('events.draft_banner.cancel_event')}
        </ConnectButton>
        <ConnectButton onClick={() => history.push('/edit')} gray={true}>
          {t('events.draft_banner.view_missing_fields')}
        </ConnectButton>
      </div>
    </Wrapper>
  );
};
